import { TipoNI } from "src/app/sitfis/model/enum/tipo-ni";
import { OrigemPendenciaPessoaJuridica, SituacaoFiscalPessoaJuridicaDto, TipoCertidao, TipoNIRequerente } from "src/app/sitfis/model/situacao-fiscal-pj-dto";

export const SITUACAO_FISCAL_PESSOA_JURIDICA_DTO: SituacaoFiscalPessoaJuridicaDto[] = [
  {
    "razaoSocial": "HMBHFIHUV KXPHIKQX H UHIEQKXU DVNW",
    "motivoEvento": "",
    "indicadorEnteFederativo": false,
    "indicadorTipoEnteFederativo": "Vinculado",
    "indicadorDisponibilidadeSimplesNacional": true,
    "pendenciasExistentes": [
      OrigemPendenciaPessoaJuridica.IrregularidadeCadastral,
      OrigemPendenciaPessoaJuridica.GfipAusencia,
      OrigemPendenciaPessoaJuridica.ContaCorrente,
      OrigemPendenciaPessoaJuridica.CcpfExigibilidade,
      OrigemPendenciaPessoaJuridica.SiefDebitoCobranca,
      OrigemPendenciaPessoaJuridica.SiefDebitoExigibilidade,
      OrigemPendenciaPessoaJuridica.SiefProcessoCobranca,
      OrigemPendenciaPessoaJuridica.SiefProcessoExigibilidade,
      OrigemPendenciaPessoaJuridica.PgfnInscricaoCobranca,
      OrigemPendenciaPessoaJuridica.PgfnInscricaoExigibilidade,
      OrigemPendenciaPessoaJuridica.QSA,
      OrigemPendenciaPessoaJuridica.OptanteParcSN,
    ],
    "pendenciasNaoExistentes": [
      // Funcionalidades ainda não mockadas
      OrigemPendenciaPessoaJuridica.DirfAusencia,
      OrigemPendenciaPessoaJuridica.DitrAusencia,
      OrigemPendenciaPessoaJuridica.DasnAusencia,
      OrigemPendenciaPessoaJuridica.DctfAusencia,
      OrigemPendenciaPessoaJuridica.SimeiAusencia,
      OrigemPendenciaPessoaJuridica.SisobraprefAusencia,
      OrigemPendenciaPessoaJuridica.PgdasAusencia,
      OrigemPendenciaPessoaJuridica.EcfAusencia,
      OrigemPendenciaPessoaJuridica.EfdAusencia,
      OrigemPendenciaPessoaJuridica.SiefProcessoArrolamento,
      OrigemPendenciaPessoaJuridica.ImpedimentoCertidaoRfb,
      OrigemPendenciaPessoaJuridica.ImpedimentoCertidaoPgfn,
      OrigemPendenciaPessoaJuridica.ItrContaCorrente,
      OrigemPendenciaPessoaJuridica.SicobDebitoCobranca,
      OrigemPendenciaPessoaJuridica.AguiaCobranca,
      OrigemPendenciaPessoaJuridica.DividaDebitoCobranca,
      OrigemPendenciaPessoaJuridica.CcitrExigibilidade,
      OrigemPendenciaPessoaJuridica.SicobDebitoExigibilidade,
      OrigemPendenciaPessoaJuridica.DividaDebitoExigibilidade,
      OrigemPendenciaPessoaJuridica.ProfiscProcessoCobranca,
      OrigemPendenciaPessoaJuridica.ProfiscProcessoExigibilidade,
      OrigemPendenciaPessoaJuridica.SipadeParcelamentoCobranca,
      OrigemPendenciaPessoaJuridica.SipadeParcelamentoExigibilidade,
      OrigemPendenciaPessoaJuridica.RefisCobranca,
      OrigemPendenciaPessoaJuridica.RefisExigibilidade,
      OrigemPendenciaPessoaJuridica.PaexParcelamentoCobranca,
      OrigemPendenciaPessoaJuridica.PaexParcelamentoExigibilidade,
      OrigemPendenciaPessoaJuridica.ParcsnCobranca,
      OrigemPendenciaPessoaJuridica.ParcsnExigibilidade,
      OrigemPendenciaPessoaJuridica.SiefparParcelamentoCobranca,
      OrigemPendenciaPessoaJuridica.SiefparParcelamentoExigibilidade,
      OrigemPendenciaPessoaJuridica.SicobParcelamentoCobranca,
      OrigemPendenciaPessoaJuridica.SicobParcelamentoExigibilidade,
      OrigemPendenciaPessoaJuridica.PgfnParcelamentoCobranca,
      OrigemPendenciaPessoaJuridica.PgfnParcelamentoExigibilidade,
      OrigemPendenciaPessoaJuridica.SisparPgfnCobranca,
      OrigemPendenciaPessoaJuridica.SisparPgfnExigibilidade,
      OrigemPendenciaPessoaJuridica.DividaParcelamentoCobranca,
      OrigemPendenciaPessoaJuridica.DividaParcelamentoExigibilidade,
    ],
    "pendenciasNaoAnalisadas": [],
    "pendenciasIndisponiveis": [],
    "pendenciasEmProcessamento": [],
    "ni": "03763656000154",
    "dataEvento": null,
    "certidaoNumeroControle": "718338EAFD98FA9A",
    "certidaoDataValidade": new Date("2024-02-12"),
    "certidaoDataEmissao": new Date("2023-08-16"),
    "tipoCertidao": TipoCertidao.Negativa,
    "numeroLiberacao": "0000006164",
    "indicadorUsoLiberacao": 3,
    "indicadorEnteFederativoPrincipal": 0,
    "indicadorVinculado": 0,
    "tipoNIRequerente": TipoNIRequerente.CNPJMatriz,
    "tipoNI": TipoNI.CNPJ,
  }
];
